module.exports = __webpack_public_path__ + "img/comma.fc5a2ed1.svg";